var _style, _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatbotIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60.3 61.7",
    style: {
      enableBackground: "new 0 0 60.3 61.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000119825448420720506440000016364717091444574366_);}\n\t.st1{fill:#2F2F2F;}\n\t.st2{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\n\t.st3{fill:none;stroke:#2F2F2F;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;}\n\t.st4{display:none;}\n\t.st5{display:inline;fill:#2F2F2F;}\n\t.st6{display:inline;fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M-1.4-5.6h150c2.8,0,5,2.2,5,5v62c0,2.8-2.2,5-5,5h-150c-2.8,0-5-2.2-5-5v-62C-6.4-3.4-4.1-5.6-1.4-5.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000024724632115340959840000011669200158474681481_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000024724632115340959840000011669200158474681481_)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.6,2.4h48c2.2,0,4,1.8,4,4v48c0,2.2-1.8,4-4,4h-48c-2.2,0-4-1.8-4-4v-48C1.6,4.2,3.4,2.4,5.6,2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M29.6,43.7c7.4,0,13.3-6,13.3-13.3c0-7.4-6-13.3-13.3-13.3s-13.3,6-13.3,13.3c0,2.4,0.6,4.7,1.8,6.7l-1.1,6 l6-1.1C24.9,43.1,27.2,43.7,29.6,43.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M24.3,27.7h5.3H35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M24.3,33.1H27h2.7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M93.6,2.4h48c2.2,0,4,1.8,4,4v48c0,2.2-1.8,4-4,4h-48c-2.2,0-4-1.8-4-4v-48C89.6,4.2,91.4,2.4,93.6,2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M123.7,39L109,24.3c-0.2-0.2-0.2-0.5,0-0.7l1.9-1.9c0.2-0.2,0.5-0.2,0.7,0l14.7,14.7c0.2,0.2,0.2,0.5,0,0.7 l-1.9,1.9C124.2,39.2,123.9,39.2,123.7,39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M109,36.5l14.7-14.7c0.2-0.2,0.5-0.2,0.7,0l1.9,1.9c0.2,0.2,0.2,0.5,0,0.7L111.6,39c-0.2,0.2-0.5,0.2-0.7,0 l-1.9-1.9C108.8,37,108.8,36.7,109,36.5z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbotIcon);
export default __webpack_public_path__ + "static/media/chatbot_icon.cd388319.svg";
export { ForwardRef as ReactComponent };